import React from 'react'
import { Link, graphql } from 'gatsby'
import Accordion from './Accordion'

import * as styles from './accordiongroup.module.scss'
import { useResponsive } from '../libs/helpers'

const AccordionGroup = ({ accordionGroup }) => {
  const [isDesktop] = useResponsive()
  const sidebarContent = accordionGroup.reduce(
    (acc, sidebarItem) => [
      ...acc,
      {
        label: sidebarItem.label,
        slug: sidebarItem.slug,
      },
    ],
    []
  )

  React.useEffect(() => {
    let lastScrollTop = 0

    function handleScroll() {
      let st = window.pageYOffset || document.documentElement.scrollTop // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

      if (st > lastScrollTop) {
        // downscroll code
        document.querySelector('#categories').style.top = '0px'
      } else if (st < lastScrollTop) {
        // upscroll code
        document.querySelector('#categories').style.top = '110px'
      } // else was horizontal scroll
      lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll, false)
    }
    return () => {
      window.removeEventListener('scroll', handleScroll, false)
      document.documentElement.style.scrollPaddingTop = ''
    }
  }, [])

  React.useEffect(() => {
    document.documentElement.style.scrollPaddingTop = isDesktop ? '115px' : '5px'
  }, [isDesktop])

  return (
    <section>
      <div className={styles['inner']}>
        <div id="categories" className={styles['sidebar']}>
          <h2>Categories</h2>
          <ul id="faq-sidebar">
            {sidebarContent.map((sidebarItem, idx) => (
              <li key={idx}>
                <Link href={`#${sidebarItem.slug}`}>{sidebarItem.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div id="faqs" className={styles['faqs']}>
          {accordionGroup.map((accordion) => (
            <Accordion key={accordion.id} {...accordion} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default AccordionGroup

export const query = graphql`
  fragment AccordionGroup on STRAPI__COMPONENT_COMPONENT_ACCORDION {
    id
    label
    slug
    accordionItem {
      question
      answer {
        type
        children {
          text
          type
          url
          children {
            text
            type
          }
        }
      }
    }
  }
`
